import { FC } from 'react'
import IconWrapper, { IconWrapperProps } from './IconWrapper'
import { ReactComponent as MyWalletIcon } from './img/wallet.svg'

type WalletIconProps = IconWrapperProps & {
  text?: string
}

export const WalletIcon: FC<WalletIconProps> = ({
  className,
  text,
  ...props
}) => {
  return (
    <IconWrapper className={className} {...props}>
      <MyWalletIcon /> {text}
    </IconWrapper>
  )
}
